<sbb-editor-node-detail-view (nodeDeleted)="nodeDeleted()"></sbb-editor-node-detail-view>
